import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, serializeDataIfNeeded, toPathString, setApiKeyToObject } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const SiteAccessLogPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog: ({ siteAccessLogCreateRequest, userAgent }, options = {}) => {
      assertParamExists("createSiteAccessLog", "siteAccessLogCreateRequest", siteAccessLogCreateRequest);
      const localVarPath = `/api-public/v2/recruiting/sites/access`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      if (userAgent !== void 0 && userAgent !== null) {
        localVarHeaderParameter["user-agent"] = String(userAgent);
      }
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(siteAccessLogCreateRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "createSiteAccessLog",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const SiteAccessLogPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = SiteAccessLogPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.createSiteAccessLog(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const SiteAccessLogPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = SiteAccessLogPublicControllerApiFp(configuration);
  return {
    /**
     * 사이트 접근 로그 저장
     * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSiteAccessLog(requestParameters, options) {
      return localVarFp.createSiteAccessLog(requestParameters, options)(axios, basePath);
    }
  };
};
class SiteAccessLogPublicControllerApi extends BaseAPI {
  /**
   * 사이트 접근 로그 저장
   * @param {SiteAccessLogPublicControllerApiCreateSiteAccessLogRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SiteAccessLogPublicControllerApi
   */
  createSiteAccessLog(requestParameters, options) {
    return SiteAccessLogPublicControllerApiFp(this.configuration).createSiteAccessLog(requestParameters, options)(this.axios, this.basePath);
  }
}
const createSiteAccessLogRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: SiteAccessLogPublicControllerApiAxiosParamCreator().createSiteAccessLog,
  requestFn: SiteAccessLogPublicControllerApiFp().createSiteAccessLog
});

export { SiteAccessLogPublicControllerApi, SiteAccessLogPublicControllerApiAxiosParamCreator, SiteAccessLogPublicControllerApiFactory, SiteAccessLogPublicControllerApiFp, createSiteAccessLogRemote };
//# sourceMappingURL=site-access-log-public-controller-api.mjs.map
